import { api, oldApi } from '@/api'
import { session } from '@/composables/useSession'
import type { Scorecard } from '@/modules/shared/TicketContent/types/scorecard'
import type { FullCategory } from '@/types/category'

interface ActiveRatingCategory {
  id: string
  name: string
  description: string
  scale: string
}

interface Category extends FullCategory {
  scorecards: Scorecard[]
}

export const getCategories = (workspaceId: number) =>
  oldApi
    .get(`payments/${session.account.id}/teams/${workspaceId}/rating-categories`)
    .json<{ data: Category[]; total: number }>()

export const getActiveCategories = (workspaceId: number) =>
  api
    .get('workspaces/active-categories', { headers: { 'X-Klaus-Workspace': workspaceId.toString() } })
    .json<{ categories: ActiveRatingCategory[] }>()
